/* eslint-disable no-restricted-syntax */
export function hideCarousel() {
  for (const element of document.getElementsByClassName('carousel')) {
    element.style.display = 'none';
  }
}
